var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-default",attrs:{"href":"#"},on:{"click":function($event){return _vm.updateView()}}},[_c('i',{staticClass:"fa",class:{ 'fa-th' : _vm.value, 'fa-sitemap' : !_vm.value },attrs:{"aria-hidden":"true"}}),_vm._v(" "),(_vm.value)?_c('span',[_vm._v("Test View")]):_c('span',[_vm._v("Overview")])])
}
var staticRenderFns = []

export { render, staticRenderFns }